export const NEW_YORK_SIRS_EXPORT_SET_REPORT_HAS_DATA =
  'NEW_YORK_SIRS_EXPORT_SET_REPORT_HAS_DATA';
export const NEW_YORK_SIRS_EXPORT_ERROR = 'NEW_YORK_SIRS_EXPORT_ERROR';
export const NEW_YORK_SIRS_EXPORT_LOADING = 'NEW_YORK_SIRS_EXPORT_LOADING';
export const NEW_YORK_SIRS_EXPORT_CONFIG_LOADING =
  'NEW_YORK_SIRS_EXPORT_CONFIG_LOADING';
export const NEW_YORK_SIRS_EXPORT_CLEAR_ERROR =
  'NEW_YORK_SIRS_EXPORT_CLEAR_ERROR';
export const NEW_YORK_SIRS_EXPORT_SET_BEDS_CODE =
  'NEW_YORK_SIRS_EXPORT_SET_BEDS_CODE';
export const NEW_YORK_SIRS_EXPORT_GET_SIRS_CODE =
  'NEW_YORK_SIRS_EXPORT_GET_SIRS_CODE';
export const NEW_YORK_SIRS_EXPORT_SET_SIRS_CODE =
  'NEW_YORK_SIRS_EXPORT_SET_SIRS_CODE';
export const NEW_YORK_SIRS_EXPORT_SET_DID_SAVE =
  'NEW_YORK_SIRS_EXPORT_SET_DID_SAVE';
export const NEW_YORK_SIRS_EXPORT_SET_CONFIG_DID_SAVE =
  'NEW_YORK_SIRS_EXPORT_SET_CONFIG_DID_SAVE';
export const NEW_YORK_SIRS_EXPORT_GET_EXPORT_CONFIG =
  'NEW_YORK_SIRS_EXPORT_GET_EXPORT_CONFIG';
export const NEW_YORK_SIRS_EXPORT_SET_EXPORT_CONFIG =
  'NEW_YORK_SIRS_EXPORT_SET_EXPORT_CONFIG';
export const NEW_YORK_SIRS_EXPORT_GET_SITES = 'NEW_YORK_SIRS_EXPORT_GET_SITES';
export const NEW_YORK_SIRS_EXPORT_RESET_EXPORT_CONFIG =
  'NEW_YORK_SIRS_EXPORT_RESET_EXPORT_CONFIG';



// WEBPACK FOOTER //
// ./src/pages/newyorksirsexport/state/export/types.js